<template>
  <div class="role-page full-height">
    <table-con>
      <div slot="breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/orders' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item>知识库</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div slot="search">
        <el-collapse v-show="queryInfo.isActive">
          <el-row class="search-row">
            <el-col :span="6" class="display-row">
              <div class="query-title">类目:</div>
              <div class="flex1">
                <el-cascader
                  ref="refSubCat"
                  :options="categoryList"
                  v-model="query.categoryId"
                  :props="{
                    value: 'id',
                    label: 'name',
                    chihildren: 'children',
                    checkStrictly: true,
                  }"
                  @change="handleSubCat"
                  size="small"
                  clearable
                ></el-cascader>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">标题:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入标题"
                  clearable
                  size="small"
                  v-model="query.title"
                >
                </el-input>
              </div>
            </el-col>
            <el-col :span="6" class="display-row">
              <div class="query-title">录入用户:</div>
              <div class="flex1">
                <el-input
                  placeholder="请输入录入用户"
                  clearable
                  size="small"
                  v-model="query.createUserName"
                >
                </el-input>
              </div>
            </el-col>
          </el-row>
        </el-collapse>
        <el-row class="search-row">
          <el-col :span="16" class="display-row">
            <div class="search-btn-container search-btn-container-status">
              &nbsp;
            </div>
          </el-col>
          <el-col :span="8" class="display-row">
            <div class="search-btn-container">
              <el-button class="search-btn btn-gray" @click="onClear"
                >重置</el-button
              >
              <el-button
                class="search-btn btn-blue"
                @click="queryInfo.searchList()"
                >搜索</el-button
              >
              <el-button class="search-btn btn-blue" @click="onAdd"
                >新增知识</el-button
              >
              <el-button class="search-btn btn-blue" @click="toCategory"
                >类目维护</el-button
              >
              <el-button
                class="search-btn btn-blue"
                v-if="!queryInfo.isActive"
                type="primary"
                icon="el-icon-arrow-down"
                alt=""
                @click="queryInfo.onActive()"
                >展开</el-button
              >
              <el-button
                class="search-btn btn-green"
                v-if="queryInfo.isActive"
                icon="el-icon-arrow-up"
                alt=""
                @click="queryInfo.onActive()"
                >收起</el-button
              >
            </div>
          </el-col>
        </el-row>
      </div>
      <div slot="table" class="full-height display-col">
        <el-table
          :header-cell-style="tableStyle.headerStyle"
          :cell-style="tableStyle.cellStyle"
          :data="pageList.tableData"
          border
          height="550"
        >
          <el-table-column type="index" label="序号" align="center" />
          <el-table-column prop="" label="操作" align="center">
            <template #default="{ row }">
              <el-button class="search-btn btn-blue" @click="onEdit(row)"
                >编辑</el-button
              >
              <el-button class="search-btn btn-red" @click="onRemove(row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
          <el-table-column prop="categoryName" label="类目" align="center">
            <template #default="{ row }">
              <span>{{ row.categoryName }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="标题" align="center" />
          <el-table-column prop="createTime" label="录入时间" align="center">
            <template #default="{ row }">
              <span>{{ row.createTime | dateFormatToSecond }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="createUserName"
            label="录入用户"
            align="center"
          />
        </el-table>
        <el-pagination
          v-bind="pagination"
          @size-change="pagination.sizeChange"
          @current-change="pagination.currentChange"
        ></el-pagination>
      </div>
    </table-con>
    <el-dialog
      :title="title"
      :visible.sync="visiable"
      v-if="visiable"
      width="50%"
    >
      <informationAdd
        :visible.sync="visiable"
        :params="queryData"
        @onchange="queryInfo.searchList()"
      />
    </el-dialog>
  </div>
</template>
<script>
//   知识库
import { PageList } from "@/class";
import informationAdd from "./informationAdd.vue";
import { listToTree } from "@/class/utils";
export default {
  name: "information",
  components: {
    informationAdd,
  },
  data() {
    const pageList = new PageList();
    const { queryInfo, pagination, page } = pageList;
    queryInfo.isActive = true;
    return {
      //列表、查询及分页
      pageList: pageList,
      queryInfo: queryInfo,
      query: queryInfo.query,
      page: page,
      pagination: pagination,
      visiable: false,
      title: undefined,
      queryData: {},
      categoryName: [],
      categoryList: [],
    };
  },
  created() {
    this.initPageList();
    this.queryInfo.searchList();
    this.getCategory();
  },
  methods: {
    onClear() {
      this.query = {};
      this.query.categoryId = [];
      this.query.oneCategoryName = undefined;
      this.query.twoCategoryName = undefined;
      this.query.threeCategoryName = undefined;
      this.queryInfo.searchList();
    },
    onRemove(row) {
      this.$http.post("/information/delete", { id: row.id }).then((res) => {
        const { data: resData } = res;
        if (resData.code == 200) {
          this.$message({
            type: "success",
            message: resData.data,
          });
          this.queryInfo.searchList();
        }
      });
    },
    handleSubCat(val) {
      console.log(val, "val");
      this.query.oneCategoryName =
        this.$refs["refSubCat"].getCheckedNodes()[0]?.pathLabels[0];
      this.query.twoCategoryName =
        this.$refs["refSubCat"].getCheckedNodes()[0]?.pathLabels[1];
      this.query.threeCategoryName =
        this.$refs["refSubCat"].getCheckedNodes()[0]?.pathLabels[2];

      this.query.oneCategoryId = this.query?.categoryId[0];
      this.query.twoCategoryId = this.query?.categoryId[1];
      this.query.threeCategoryId = this.query?.categoryId[2];
      console.log(this.queryInfo, "this.queryInfo");
    },
    // 类目维护
    toCategory() {
      this.$router.push({ path: "informationCategory" });
    },
    // 添加
    onAdd() {
      this.visiable = true;
      this.title = "添加知识库";
      this.queryData = {};
    },
    // 编辑
    onEdit(row) {
      this.visiable = true;
      this.title = "编辑知识库";
      this.queryData = row;
    },
    initPageList() {
      //重写请求列表接口
      this.queryInfo.searchList = () => {
        let params = {
          ...this.page,
          ...this.query,
          categoryId: [],
        };
        console.log(params, "params");
        this.$http
          .get("/information/list", {
            params: params,
          })
          .then((res) => {
            const { data: resData } = res;
            this.pageList.update(resData);
            this.pageList.tableData.forEach((item) => {
              this.categoryName = [];
              item.categoryName = [
                item?.oneCategoryName || null,
                item?.twoCategoryName || null,
                item?.threeCategoryName || null,
              ];
              item.categoryName = item.categoryName.filter((item) => {
                return item != null;
              });
              item.categoryName = item.categoryName.join("-");
            });
          });
      };
    },
    // 分类
    getCategory() {
      this.$http.get("informationCategory/list").then((res) => {
        const { data: resData } = res;
        if (resData.code == 200) {
          this.categoryList = listToTree(resData.data.list, "id", "parentId");
        }
      });
    },
  },
};
</script>
<style scoped></style>
